import React from "react";
import { motion } from "framer-motion";
import { typeToIconClass } from "../question";

interface TypeBubbleProps {
  type: string;
  icon: string;
  selected: boolean;
  onClick: () => void;
  disabled: boolean;
}

const TypeBubble: React.FC<TypeBubbleProps> = ({
  type,
  icon,
  selected,
  onClick,
  disabled,
}) => (
  <motion.button
    onClick={onClick}
    disabled={disabled}
    className={`p-2 rounded-full flex text-[10px] items-center gap-2 transition ease-in-out duration-500 ${
      selected
        ? "bg-indigo-100 text-indigo-700 border-indigo-300"
        : "bg-neutral-50 text-neutral-700 hover:bg-indigo-100 hover:text-indigo-700"
    } ${
      disabled && !selected ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
    }`}
    whileTap={{ scale: 0.95 }}
  >
    <i className={icon} />
    <span className="text-xs capitalize">{type.replace("-", " ")}</span>
  </motion.button>
);

interface TypesStepProps {
  selectedTypes: string[];
  onTypeSelect: (type: string) => void;
  onNext?: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
}

const TypesStep: React.FC<TypesStepProps> = ({
  selectedTypes,
  onTypeSelect,
  onNext,
  onKeyDown,
}) => {
  return (
    <div
      className="flex flex-wrap gap-2 max-h-64 overflow-y-auto"
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      {Object.entries(typeToIconClass).map(([type, icon]) => (
        <TypeBubble
          key={type}
          type={type}
          icon={icon}
          selected={selectedTypes.includes(type)}
          onClick={() => onTypeSelect(type)}
          disabled={!selectedTypes.includes(type) && selectedTypes.length >= 3}
        />
      ))}
    </div>
  );
};

export default TypesStep;
